import { cn } from "@/libs/cn";
import { Tooltip as TooltipPrimitive } from "@kobalte/core/tooltip";
import { mergeProps, splitProps } from "solid-js";

export const TooltipTrigger = TooltipPrimitive.Trigger;

export const Tooltip = (props) => {
	const merge = mergeProps(
		{
			gutter: 4,
			flip: false,
		},
		props
	);

	return <TooltipPrimitive {...merge} />;
};

export const TooltipContent = (props) => {
	const [local, rest] = splitProps(props, ["class"]);

	return (
		<TooltipPrimitive.Portal>
			<TooltipPrimitive.Content
				class={cn(
					"z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground data-[expanded]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[expanded]:fade-in-0 data-[closed]:zoom-out-95 data-[expanded]:zoom-in-95",
					local.class
				)}
				{...rest}
			/>
		</TooltipPrimitive.Portal>
	);
};
